import type { FaireProductEntity } from "../../entity_types/product";

export const p_t3dngtatcj: FaireProductEntity = {
  token: "p_t3dngtatcj",
  type: "product",
  name: "Black Drawing Salve",
  brandToken: "b_rvn46uxywb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/9e10d47782776e322bda4389477fe77a73b7487ea22e0b201bb1ee1a690a2d4d.jpeg",
  galleryImageUrls: [],
  priceDollars: 5.55,
  description:
    "Traditionally used to draw out small foreign objects such as splinters, glass, or stingers. Mucilage rich, cooling herbs help soften the skin allowing the foreign object to be expelled while reducing itching & burning associated with bites & stings.\n\n1 oz. tin",
  tags: [],
  msrpDollars: 11.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:32.476Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
